<img class="full-size"
     src="/assets/loading_green.gif"
     alt="loading">